import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Loader from '../../../Components/Spinner/Loader';
import ShowingPasswordValidationText from '../../../Components/Common/ShowingPasswordValidationText';

const PortalLogin = ({ register, loading, watch }: any) => {
  const [passwordType, setPasswordType] = useState('password');
  return (
    <>
      {' '}
      <div className='register-top '>
        <div className='register-top-div'>
          <h3>Exhibitor Portal Credential</h3>
        </div>
        <div className='register-top-form-card '>
          <div className='row g-3 '>
            <div className='col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4'>
              <div className='row'>
                <label>
                  Email<span className='require'>*</span>
                </label>
                <div className='w-150-100'>
                  <input
                    required
                    type='email'
                    {...register('user_fair_member_email')}
                    className='form-control '
                    placeholder='Enter email'
                  />
                </div>
              </div>
            </div>

            <div className='col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4'>
              <div className='row d-flex'>
                <label>
                  Password <span className='require'>*</span>
                </label>
                <div className='w-150-100'>
                  <input
                    type={passwordType}
                    id='password'
                    {...register('user_fair_member_password')}
                    className='form-control error'
                    placeholder='Password'
                  />
                  {((watch('user_fair_member_password') &&
                    watch('user_fair_member_password')?.length < 8) ||
                    watch('user_fair_member_password')?.length > 16) && (
                    <ShowingPasswordValidationText />
                  )}
                  <label id='password-error' className='error'></label>
                </div>
              </div>
            </div>

            <div className='col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4'>
              <div className='row'>
                <label>
                  Confirm Password <span className='require'>*</span>
                </label>
                <div className='w-150-100'>
                  <input
                    required
                    type={passwordType}
                    className='form-control error'
                    {...register('user_fair_member_confirm_password')}
                    placeholder='Confirm Password'
                  />
                  <label id='confirm_password-error' className='error'></label>
                </div>
              </div>
            </div>
          </div>

          <div className='d-flex align-items-center gap-2'>
            <input
              type='checkbox'
              onClick={(e: any) => {
                if (e.target.checked) {
                  setPasswordType('text');
                } else {
                  setPasswordType('password');
                }
              }}
              id=''
            />
            <p>Show password</p>
          </div>
          <div className='text-center mt-3'>
            {loading ? (
              <Loader css={'w-50'} />
            ) : (
              <Button
                type='submit'
                className='w-50 submit-button common-btn'
                variant='primary'
              >
                Submit
              </Button>
            )}
          </div>
          <div className='text-end'>
            Back to{' '}
            <Link
              to='/login'
              style={{ fontWeight: 'bold' }}
              className='text-decoration-none'
            >
              Login
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default PortalLogin;
